export default __webpack_public_path__ + "static/media/spinner.01a319d3.gif";